let back_buttons = document.querySelectorAll('[data-goback]');

back_buttons.forEach(element => {
    element.addEventListener('click', (e) => {
        e.preventDefault();
        window.history.back();
    });
});